import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import {
  ContactRelationshipsService,
  RelationshipCategory,
  RelationshipType,
} from '../../../../../core/lists';
import { EntityType } from '../../models';
import { EntityType as Type } from '../../enums';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';

@Component({
  selector: 'kt-select-relation',
  templateUrl: './select-relation.component.html',
})
export class SelectRelationComponent implements AfterViewInit {
  entityTypes = Object.values(Type);
  getRelationCategoryAutocomplete;
  getRelationTypeAutocomplete;
  @ViewChild('entityTypeSelect') entityTypeSelect: MatSelect;
  @ViewChild('relationCategoryAutocomplete')
  relationCategoryAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('relationTypeAutocomplete') relationTypeAutocomplete: GeneralAutocompleteComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      entityTypes: EntityType[];
      relationCategories: RelationshipCategory[];
      relationTypes: RelationshipType[];
    },
    public stringUtils: StringUtilsService,
    private dialogRef: MatDialogRef<SelectRelationComponent>,
    private relationshipsService: ContactRelationshipsService,
  ) {}

  ngAfterViewInit(): void {
    this.getRelationCategoryAutocomplete = this.relationshipsService.getRelations.bind(
      this.relationshipsService,
      this.data.entityTypes,
    );

    this.entityTypeSelect.value = this.data.entityTypes || [];
    this.relationCategoryAutocomplete.setValue(this.data.relationCategories || []);
    this.relationCategoryAutocomplete.updateValueAndValidity();
    this.relationTypeAutocomplete.setValue(this.data.relationTypes || []);
    this.relationTypeAutocomplete.updateValueAndValidity();
  }

  formatRelationCategoryOption(relationCategory: RelationshipCategory): string {
    return relationCategory
      ? `${relationCategory.name}<small class="text-muted ml-2">(${relationCategory.entity_type})</small>`
      : '';
  }

  formatNewRelationCategory(relationCategory: RelationshipCategory): RelationshipCategory {
    return relationCategory;
  }

  handleRelationCategoryChange(relationCategories: RelationshipCategory[]): void {
    if (relationCategories?.length) {
      this.getRelationTypeAutocomplete = this.relationshipsService.getRelations.bind(
        this.relationshipsService,
        [],
        relationCategories,
      );
    } else {
      this.relationTypeAutocomplete.setValue([]);
      this.relationTypeAutocomplete.updateValueAndValidity();
    }
  }

  formatRelationTypeOption(relationType: RelationshipType): string {
    return relationType
      ? `${relationType.description_type}<small class="text-muted ml-2">(${
          relationType.category?.name || ''
        })</small>`
      : '';
  }

  formatNewRelationType(relationType: RelationshipType): RelationshipType {
    return relationType;
  }

  closeDialog(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  submit(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close({
      relationCategories: this.relationCategoryAutocomplete.value,
      relationTypes: this.relationTypeAutocomplete.value,
    });
  }
}
